<div class="briefing-container" fxLayout="column" fxLayoutAlign="start center">
  <mat-card class="briefing-card" fxFlex="grow">
    <mat-card-header fxLayout="column" fxLayoutAlign="start stretch" class="briefing-header">

      <!-- Linha Superior: Título e Sistema -->
      <div fxLayout="row" fxLayoutAlign="space-between center" class="header-top-row">
        <mat-card-title fxFlex="grow">{{ briefingTitle }}</mat-card-title>
        <!-- Detalhes do Sistema (Direita Superior) -->
        <div fxLayout="row" fxLayoutAlign="end center" class="detail-item system-details-top-right">
          <div>
            <img *ngIf="briefing?.system?.image as systemImage" [src]="getSystemImageUrl(systemImage)"
              alt="Logo Sistema" class="system-logo">
          </div>
        </div>
      </div>

      <!-- Linha Inferior: Cliente e Parceiro -->
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="20px grid" class="briefing-details-bottom">
        <div fxLayout="row" fxLayoutAlign="center center" class="detail-item">
          <mat-icon>person</mat-icon>
          <div>
            <span class="detail-label">Cliente: </span>
            <span class="detail-value">{{ briefing?.customerName || 'N/A' }}</span>
          </div>
        </div>

        <div *ngIf="briefing?.partnerName" fxLayout="row" fxLayoutAlign="center center" class="detail-item">
          <mat-icon>business</mat-icon>
          <div>
            <span class="detail-label">Parceiro: </span>
            <span class="detail-value">{{ briefing?.partnerName }}</span>
          </div>
        </div>
        <div *ngIf="briefing?.partnerName" fxLayout="row" fxLayoutAlign="center center" class="detail-item">
          <mat-icon>widgets</mat-icon>
          <div>
            <span class="detail-label">Solução: </span>
            <span class="detail-value">{{ briefing?.systemName || 'N/A' }}</span>
          </div>
        </div>
      </div>

    </mat-card-header>

    <mat-card-content fxLayout="column" fxLayoutGap="25px">
      <div *ngIf="isLoading" class="loading-indicator" fxLayout="column" fxLayoutAlign="center center">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Carregando formulário...</p>
      </div>

      <div *ngIf="!isLoading && isSubmitted" class="submitted-message" fxLayout="column" fxLayoutAlign="center center">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <h2>Obrigado!</h2>
        <p>Seu briefing foi enviado com sucesso.</p>
        <div class="loader-container" *ngIf="generatedContractFlag && !viewSignatures">
          <div class="loader"></div>
          <p class="loader-text">Gerando contrato, Aguarde.</p>
        </div>
        <div class="signatures-list-container" *ngIf = "viewSignatures">
          <div class="form-title">
            <h2>Assinaturas</h2>
          </div>
          <mat-card class="signature-item" *ngFor="let signature of contractCustomer[0].signatures" (click)="openlinkContract(signature.signUrl)">
            <div class="signature-details">
              <p class="mat-body-strong signature-name">{{ signature.name }}</p>
              <p class="mat-small signature-email">{{ signature.email }}</p>
              <p class="mat-small signature-whatsapp">{{ signature.whatsAppNumber }}</p>
            </div>
            <div class="signature-action" (click)="$event.stopPropagation()">
              <button mat-flat-button (click)="copyAllLinks()">
                <mat-icon>copy_all</mat-icon>
              </button>
              <button mat-flat-button (click)="copyLinkContract(signature.signUrl)">
                <mat-icon>content_copy</mat-icon>
              </button>
              <button mat-flat-button  (click)="sendWhatsAppLink(signature.whatsAppNumber,signature.signUrl)">
              <img src="assets/img/whatsapp.svg"
                style="width: 30px; height: 30px;" class="whatsapp-icon">
              </button>
            </div>

          </mat-card>
        </div>
      </div>

      <form *ngIf="!isLoading && !isSubmitted && formDefinition.length > 0" [formGroup]="responseForm" (ngSubmit)="onSubmit()">
        <!-- Cadastro básico  -->
        <mat-stepper #stepper  labelPosition="bottom">
          <mat-step  *ngIf="isRegister">
                <div class="form-title">
                  <h2>Cadastro Básico</h2>
                </div>
            <ng-container *ngFor="let field of formDefinition">
              <app-input *ngIf="field.type !== inputTypeEnum.INPUT_FILE 
              && field.type !== inputTypeEnum.INPUT_FILE_WITH_COMMENT_AND_DATE 
              && isBasicRegistrationField(field.name)
              "
              [config]="field" [group]="responseForm" (onSelect)="onLegalPersonalityChange($event)">
              </app-input>
            </ng-container>
            <div class="stepper-buttons">
              <button mat-raised-button color="primary" matStepperNext type="button" >Próximo</button>
            </div>
         </mat-step>
         <!-- Cadastro de Endereço -->
          <mat-step  *ngIf="isRegister">
                <div class="form-title">
                  <h2>Endereço</h2>
                </div>
            <ng-container *ngFor="let field of formDefinition">
              <app-input *ngIf="field.type !== inputTypeEnum.INPUT_FILE 
              &&  field.type !== inputTypeEnum.INPUT_FILE_WITH_COMMENT_AND_DATE 
              && isAddressRegistrationField(field.name)" 
              (onChange)="onChangeCep()"
              [config]="field" [group]="responseForm">
              </app-input>
            </ng-container>
            <div class="stepper-buttons">
              <button mat-raised-button  matStepperPrevious type="button">Voltar</button>
              <button mat-raised-button color="primary" matStepperNext type="button">Próximo</button>
            </div>
         </mat-step>
        <!-- Planos -->
         <mat-step  *ngIf="isRegister && !isRegisterPartners && mandatoryPlan">
                <div class="form-title">
                  <h2>Planos</h2>
                </div>
              <ng-container *ngFor="let field of formDefinition">
                <app-input *ngIf="field.type !== inputTypeEnum.INPUT_FILE 
                &&  field.type !== inputTypeEnum.INPUT_FILE_WITH_COMMENT_AND_DATE 
                && isPlansRegistrationField(field.name)" 
                (onSelect)="loadPlans(field.name)"
                [isMultipleSelect]="MultipleSelect(field.name)"
                [config]="field" [group]="responseForm">
                </app-input>
               
            </ng-container>
            <mat-hint>Caso não tenha Implantação, digite 0</mat-hint>
             <button *ngIf="false" mat-raised-button color="primary"  type="button" (click)="generateContractModal()" >Gerar Contrato?</button>
            <div class="stepper-buttons">
              <button mat-raised-button  matStepperPrevious type="button">Voltar</button>
              <button mat-raised-button color="primary" matStepperNext type="button">Próximo</button>
            </div>
         </mat-step>
        <!-- Configurações e Login para Parceiros -->
         <mat-step  *ngIf="isRegister && isRegisterPartners">
                <div class="form-title">
                  <h2>Configurações</h2>
                </div>
              <ng-container *ngFor="let field of formDefinition">
              <app-input *ngIf="field.type !== inputTypeEnum.INPUT_FILE 
              &&  field.type !== inputTypeEnum.INPUT_FILE_WITH_COMMENT_AND_DATE 
              && isConfigPartnersRegistrationField(field.name)" 
              (onChange)="onChangeCep()"
              [config]="field" [group]="responseForm">
              </app-input>
            </ng-container>
              
            <div class="stepper-buttons">
              <button mat-raised-button  matStepperPrevious type="button">Voltar</button>
              <button mat-raised-button color="primary" matStepperNext type="button">Próximo</button>
            </div>
         </mat-step>

         <mat-step  *ngIf="!isRegister">
                <div class="form-title">
                  <h2>Preencha as informações</h2>
                </div>
            <ng-container *ngFor="let field of formDefinition">
              <app-input *ngIf="field.type !== inputTypeEnum.INPUT_FILE 
              && field.type !== inputTypeEnum.INPUT_FILE_WITH_COMMENT_AND_DATE 
              && getFieldConfig(field.name) 
              "
              [config]="field" [group]="responseForm">
              </app-input>
            </ng-container>
            <div class="stepper-buttons">
              <button mat-raised-button color="primary" matStepperNext type="button">Próximo</button>
            </div>
         </mat-step>
         <!-- Para arquivos -->
          <mat-step  *ngIf="!isRegisterPartners">
                <div class="form-title">
                  <h2>Arquivos</h2>
                </div>
            <div *ngFor="let field of formDefinition">
              <div *ngIf="field.type === inputTypeEnum.INPUT_FILE || field.type === inputTypeEnum.INPUT_FILE_WITH_COMMENT_AND_DATE" class="input-file-container">
                <label class="input-file-label">{{ field.label }}</label>
                <div class="file-accept-info" *ngIf="field.accept">
                  <small>Tipos de arquivo aceitos: {{ formatAcceptInfo(field.accept) }}</small>
                </div>
                <div class="file-multiple-info" *ngIf="field.multiple">
                  <small>Você pode selecionar vários arquivos ao mesmo tempo.</small>
                </div>
                <button type="button" mat-stroked-button color="primary" class="select-files-button" (click)="fileInput.click()">
                  <mat-icon>attach_file</mat-icon>
                  Selecionar Arquivo{{ field.multiple ? '(s)' : '' }}
                </button>
                <input type="file" hidden [attr.accept]="field.accept || '*/*'" [multiple]="field.multiple || false" (change)="onFileSelected($event, field.name)" #fileInput>
                <div class="file-count" *ngIf="selectedFiles[field.name] && selectedFiles[field.name].length > 0">
                  <small>{{ selectedFiles[field.name].length }} arquivo(s) selecionado(s)</small>
                </div>
                <button type="button" mat-icon-button color="warn" class="clear-files-button" *ngIf="selectedFiles[field.name] && selectedFiles[field.name].length > 0" (click)="clearFiles(field.name)" matTooltip="Limpar seleção">
                  <mat-icon>clear</mat-icon>
                </button>
                <div class="selected-files-area" *ngIf="selectedFiles[field.name] as files; else noFilesSelected">
                  <ng-container *ngIf="imagePreviews[field.name] as previews">
                    <div class="previews-container" *ngIf="previews.length > 0">
                      <div *ngFor="let preview of previews" class="preview-container">
                        <img [src]="preview" alt="Preview" class="image-preview">
                      </div>
                    </div>
                  </ng-container>
                  <ul class="file-list" *ngIf="files.length > 0">
                    <li *ngFor="let file of files" class="file-item">
                      <div class="file-info">
                        <mat-icon>{{ getFileIcon(file.type) }}</mat-icon>
                        <span class="file-name">{{ file.name }}</span>
                        <span class="file-size">({{ formatFileSize(file.size) }})</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <ng-template #noFilesSelected>
                  <div class="no-files-selected">
                    <p><mat-icon>info</mat-icon> Nenhum arquivo selecionado</p>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="stepper-buttons">
              <button mat-raised-button  matStepperPrevious type="button">Voltar</button>
              <button mat-raised-button color="primary" matStepperNext type="button">Próximo</button>
            </div>
            
          </mat-step>

 

          <mat-step>
            <!-- <ng-template matStepLabel>Enviar</ng-template> -->
            <h2>Envio</h2>
            <div class="form-actions" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px">
              <button mat-raised-button color="primary" type="submit" [disabled]=" isLoading">
                <mat-spinner *ngIf="isLoading" [diameter]="24" mode="indeterminate"></mat-spinner>
                <span *ngIf="!isLoading && !isRegisterCustomers">Enviar Briefing</span>
                <span *ngIf="!isLoading && isRegisterCustomers">Salvar Briefing</span>
              </button>
              <button *ngIf="isRegisterCustomers" mat-raised-button color="accent"  type="button" (click)="generateContractModal()" >Criar Cadastro</button>
            </div>
          </mat-step>
        </mat-stepper>
      </form>

      <div *ngIf="!isLoading && !isSubmitted && formDefinition.length === 0">
        <p class="error-message">Não foi possível carregar as perguntas para este tipo de briefing.</p>
      </div>

    </mat-card-content>
  </mat-card>
</div>